var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"dropdown",class:[
    "bg-white",
    "dropdown-container",
  ],style:({width: `${_vm.containerWidth}px`}),on:{"mouseenter":function($event){$event.stopPropagation();return _vm.$emit("update:hovering", true)},"mouseleave":function($event){$event.stopPropagation();return _vm.$emit("update:hovering", false)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }